import { render, staticRenderFns } from "./SplitScreen.vue?vue&type=template&id=4aecb453&scoped=true"
import script from "./SplitScreen.vue?vue&type=script&lang=js"
export * from "./SplitScreen.vue?vue&type=script&lang=js"
import style0 from "./SplitScreen.vue?vue&type=style&index=0&id=4aecb453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aecb453",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
